import { Contact, KanbanStage } from '@/types/crm';
import { LeadCard } from './LeadCard';

interface KanbanColumnProps {
  stage: KanbanStage;
  leads: Contact[];
}

export const KanbanColumn = ({ stage, leads }: KanbanColumnProps) => {
  return (
    <div className="glass rounded-2xl min-w-[320px] max-w-[360px] h-[calc(100vh-220px)] flex flex-col shrink-0">
      {/* Header */}
      <div 
        className="p-4 glass-strong rounded-t-2xl border-b border-border/50"
        style={{ borderTopWidth: '3px', borderTopColor: stage.color }}
      >
        <div className="flex items-center gap-2">
          <span className="text-xl">{stage.icon}</span>
          <h2 className="text-base font-semibold text-foreground flex-1">
            {stage.title}
          </h2>
          <span 
            className="px-2.5 py-1 rounded-full text-sm font-semibold"
            style={{ 
              backgroundColor: `${stage.color}30`,
              color: stage.color 
            }}
          >
            {leads.length}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {leads.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <p className="text-sm">Nenhum lead nesta etapa</p>
          </div>
        ) : (
          leads.map((lead) => <LeadCard key={lead.id} contact={lead} />)
        )}
      </div>
    </div>
  );
};
